import { IDominioForm } from '../../../../../modules/types/Dominio';

export const defaultFormMain: IDominioForm = {
  id: 0,
  dominioPaiId: null,
  corId: 0,
  corText: 1,
  status: 0,
  ordem: 0,
  nome: '',
  descricao: '',
  observacoes: '',
};
